import {
  UntypedFormGroup,
  UntypedFormControl,
  ValidatorFn,
  AbstractControl,
  FormControl,
  FormArray,
  ValidationErrors,
} from "@angular/forms";
import { IBOQAmendmentDetail } from "src/app/pages/master/models/boq.model";
import {
  IWorkOrder,
  IWorkOrderDetails,
} from "src/app/pages/master/models/workorder.model";

export function emailValidator(control: UntypedFormControl): {
  [key: string]: any;
} {
  var emailRegexp = /[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$/;
  if (control.value && !emailRegexp.test(control.value)) {
    return { invalidEmail: true };
  }
}

export function matchingPasswords(
  passwordKey: string,
  passwordConfirmationKey: string
) {
  return (group: UntypedFormGroup) => {
    let password = group.controls[passwordKey];
    let passwordConfirmation = group.controls[passwordConfirmationKey];
    if (password.value !== passwordConfirmation.value) {
      return passwordConfirmation.setErrors({ mismatchedPasswords: true });
    }
  };
}
export function uniqueBOQValidator(boqNumbers: any[]): ValidatorFn {
  return (control: AbstractControl): { [key: string]: boolean } | null => {
    if (control.value !== undefined && boqNumbers.includes(control.value)) {
      return { duplicateBOQ: true };
    }
    return null;
  };
}
export function uniqueBOQValidatorFormControl(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const boqNumber = control.value;  // Get current value
    const allBoqNumbers = formArray.controls.map(ctrl => ctrl.get('boqNumber')?.value);

    const duplicateCount = allBoqNumbers.filter(value => value === boqNumber).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateBOQ: true } : null;
  };
}

export function uniqueSubContWOFormControl(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const boqNumber = control.value;  // Get current value
    const allBoqNumbers = formArray.controls.map(ctrl => ctrl.get('workOrderDetailKey')?.value);

    const duplicateCount = allBoqNumbers.filter(value => value === boqNumber).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateSubWO: true } : null;
  };
}

export function uniqueBillWOFormControl(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const boqNumber = control.value;  // Get current value
    const allBoqNumbers = formArray.controls.map(ctrl => ctrl.get('subConWoDetailsKey')?.value);

    const duplicateCount = allBoqNumbers.filter(value => value === boqNumber).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateSubWO: true } : null;
  };
}


export function uniqueProductForSCFormControl(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const productName = control.value;  // Get current value
    const allproductNames = formArray.controls.map(ctrl => ctrl.get('productKey')?.value);

    const duplicateCount = allproductNames.filter(value => value === productName).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateProduct: true } : null;
  };
}

export function uniqueProductPerWOValidator(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl) => {
    const currentWO = control.parent?.get('subConWoDetailsKey')?.value;
    const currentProduct = control.value;

    if (!currentWO || !currentProduct) return null;

    // Count products under the same WO
    const duplicateCount = formArray.controls.filter(item => 
      item.get('subConWoDetailsKey')?.value === currentWO &&
      item.get('productKey')?.value === currentProduct
    ).length;

    return duplicateCount > 1 ? { duplicateProduct: true } : null;
  };
}


export function uniqueUserValidator(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const firstName = control.value;  // Get current value
    const allEmployeeNames = formArray.controls.map(ctrl => ctrl.get('userKey')?.value);

    const duplicateCount = allEmployeeNames.filter(value => value === firstName).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateUser: true } : null;
  };
}

export function uniqueExpenseTyperValidator(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const expenseType = control.value;  // Get current value
    const allexpenseTypes = formArray.controls.map(ctrl => ctrl.get('expenseTypeKey')?.value);

    const duplicateCount = allexpenseTypes.filter(value => value === expenseType).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateExpenseType: true } : null;
  };
}

export function uniqueMaterialTypeValidator(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value) return null;
    const duplicate = formArray.controls.some((group) => {
      return group !== control.parent && group.get('materialType')?.value === control.value;
    });
    return duplicate ? { duplicateMaterialType: true } : null;
  };
}

export function uniqueExpenseTypeValidator(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const expenseType = control.value;  // Get current value
    const allexpenseTypes = formArray.controls.map(ctrl => ctrl.get('expense_type_id')?.value);

    const duplicateCount = allexpenseTypes.filter(value => value === expenseType).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateExpenseType: true } : null;
  };
}

export function workOrderQtyValidator(
  workOrder: IWorkOrderDetails
): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === 0) {
      return { zero: true };
    } else {
      if (control.value < -workOrder.previousAmendment) {
        return { less: true, previousAmendment: -workOrder.previousAmendment };
      }
    }
    return null;
  };
}
export function sameProductTypeForSameProduct(
  boqDetails: any,
  index: number
): ValidatorFn {
  return (control: AbstractControl) => {
    const currentRowProduct = boqDetails.at(index).value?.product;
    const dupeRow = boqDetails.find((detail, i) => {
      const value = detail.value;
      return value.product == currentRowProduct && i !== index;
    });
    if (dupeRow && dupeRow.get("productType")?.value !== control.value) {
      return { dupeType: true };
    }
    return null;
  };
}
export function sameWorkTypeForSameWOCode(
  boqDetails: any,
  index: number
): ValidatorFn {
  return (control: AbstractControl) => {
    const currentWODetail = boqDetails.at(index).value?.workOrderDetailsKey;
    const dupeRow = boqDetails.find((detail, i) => {
      const value = detail.value;
      return value.workOrderDetailsKey == currentWODetail && i !== index;
    });
    if (dupeRow && dupeRow.get("workType")?.value !== control.value) {
      return { dupeType: true };
    }
    return null;
  };
}
export function nonZero(control: AbstractControl) {
  if (control.value === 0) {
    return { nonZero: true };
  }
  return null;
}
export function boqQtyValidator(boqDetail: IBOQAmendmentDetail): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    if (control.value === 0) {
      return { zero: true };
    } else {
      if (control.value < -boqDetail.boqQty) {
        return { less: true, quantity: -boqDetail.boqQty };
      }
    }
    return null;
  };
}
export function dupeProductForPO(boqDetails: any[], index:number): ValidatorFn {
  return (control: AbstractControl) => {
    if (control?.value) {
      const dupeRow = boqDetails?.filter(
        (boqDetail, i) => boqDetail?.getRawValue()?.productCode === control?.value
      );

      if (dupeRow?.length >= 2) {
        return { dupeProduct: true };
      }
    }
    return null;
  };
}

export function dupeOtherCharge(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const otherChargesType = control.value;  // Get current value
    const allotherChargesType = formArray.controls.map(ctrl => ctrl.get('otherChargesType')?.value);

    const duplicateCount = allotherChargesType.filter(value => value === otherChargesType).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicateOtherCharges: true } : null;
  };
}

export function dupedeposite(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const otherChargesType = control.value;  // Get current value
    const allotherChargesType = formArray.controls.map(ctrl => ctrl.get('depositeType')?.value);

    const duplicateCount = allotherChargesType.filter(value => value === otherChargesType).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicatedeposite: true } : null;
  };
}


export function duppaymentTerms(formArray: FormArray): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const otherChargesType = control.value;  // Get current value
    const allotherChargesType = formArray.controls.map(ctrl => ctrl.get('paymentTermKey')?.value);

    const duplicateCount = allotherChargesType.filter(value => value === otherChargesType).length;

    // If there is more than one occurrence of the boqNumber, it's a duplicate
    return duplicateCount > 1 ? { duplicatePayment: true } : null;
  };
}

export function imageFileValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const file = control.value;
    if (!file) return null; // handled by required if needed

    const validTypes = ['image/jpeg', 'image/png'];
    return validTypes.includes(file.type) ? null : { invalidFileType: true };
  };
}

export function maxTwoDecimalValidator(control: AbstractControl): ValidationErrors | null {
  if (control.value == null) return null;
  const value = control.value.toString();
  const regex = /^\d+(\.\d{1,2})?$/;
  return regex.test(value) ? null : { decimalInvalid: true };
}